(function () {
  'use strict';

  function initVSOrderTracking(root) {

    if (!root) {
      return;
    }

    if (root.dataset.vsInitialized === 'true') {
      return;
    }

    root.dataset.vsInitialized = 'true';


    /* ================================================
       TRACKING TOGGLE
    ================================================= */

    const buttons = root.querySelectorAll(
      '[data-vs-toggle-tracking]'
    );

    buttons.forEach(function (button) {

      button.addEventListener('click', function () {

        const card = button.closest(
          '[data-vs-order-card]'
        );

        if (!card) {
          return;
        }

        const panel = card.querySelector(
          '[data-vs-tracking-panel]'
        );

        if (!panel) {
          return;
        }

        if (panel.hasAttribute('hidden')) {

          panel.removeAttribute('hidden');

          button.textContent = 'Hide Tracking';

        } else {

          panel.setAttribute('hidden', '');

          button.textContent = 'Track Package';

        }

      });

    });


    /* ================================================
       LOGIN BUTTON
    ================================================= */

    const loginButton = root.querySelector(
      '.vs-login-button'
    );

    if (loginButton) {

      loginButton.addEventListener(
        'click',
        function () {

          loginButton.style.opacity = '0.75';
          loginButton.style.pointerEvents = 'none';

        }
      );

    }

  }


  function initAll() {

    const sections = document.querySelectorAll(
      '[data-vs-order-tracking]'
    );

    sections.forEach(function (section) {
      initVSOrderTracking(section);
    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* ================================================
     SHOPIFY THEME EDITOR
  ================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section = event.target.querySelector(
        '[data-vs-order-tracking]'
      );

      if (section) {
        initVSOrderTracking(section);
      }

    }
  );


})();